import styled from 'styled-components';
import { Dispatch, SetStateAction } from 'react';
import { ImageUtils } from '../../utils/ImageUtils';

export const SwitchButton = ({
  agreeStatus,
  setAgreeStatus,
}: {
  agreeStatus: null | boolean;
  setAgreeStatus: Dispatch<SetStateAction<boolean | null>>;
}) => {
  return (
    <ButtonContainer>
      <Button $isActive={agreeStatus} onClick={() => setAgreeStatus(true)}>
        <TextImg src={agreeStatus === true ? ImageUtils.CheckActive : ImageUtils.Check} />
        <ButtonText $isActive={agreeStatus}>예</ButtonText>
      </Button>
      <Button $isActive={agreeStatus === false} onClick={() => setAgreeStatus(false)}>
        <TextImg src={agreeStatus === false ? ImageUtils.CheckActive : ImageUtils.Check} />
        <ButtonText $isActive={agreeStatus === false}>아니오</ButtonText>
      </Button>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const Button = styled.button<{ $isActive: boolean | null }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  border: 1px solid ${({ $isActive }) => ($isActive ? '#fbf6d5' : '#3c3b3b')};
  background: ${({ $isActive }) => ($isActive ? '#201F1E' : '#32302f')};
  height: 40px;
  transition: 0.05s ease-in;
  flex: 1;

  &:active {
    transform: scale(0.95);
  }

  &:first-child {
    margin-right: 4px;
  }
`;

const ButtonText = styled.span<{ $isActive: boolean | null }>`
  color: ${({ $isActive }) => ($isActive ? '#FBF6D5' : '#777777')};
  font-size: 16px;
  line-height: 17px;
  letter-spacing: -0.48px;
`;

const TextImg = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 6px;
`;
